import { Form, Table } from "react-bootstrap";

const GLXBABEGLM = ({ output }) => {

    const GLXBABEGLMOUTPUT = (data) => {
        const grouped = {};
        data?.forEach(d => {
            d.table?.forEach(row => {
                const param = row.PARAMCD;
                if (!grouped[param]) grouped[param] = {};
                if (!grouped[param][d.name]) grouped[param][d.name] = [];
                grouped[param][d.name].push(row);
            });
        });
        const parameters = Object.keys(grouped);
        const getTrtanNames = (param) => {
            const lsmeansTable = grouped[param]?.[`lsmeans_${param}`] || [];
            const trtanNames = lsmeansTable
                .map(r => r.TRTAN)
                .filter((value, index, self) => self.indexOf(value) === index);
            const REF_TRT_NAME = trtanNames[0] || 'R';
            const TEST_TRT_NAME = trtanNames[1] || 'T';

            return { TEST_TRT_NAME, REF_TRT_NAME };
        }

        const { TEST_TRT_NAME, REF_TRT_NAME } = parameters.length > 0
            ? getTrtanNames(parameters[0])
            : { TEST_TRT_NAME: 'T', REF_TRT_NAME: 'R' };


        const getVal = (obj, key, digits = 4) => {
            const value = obj && obj[key] !== undefined ? obj[key] : null;
            if (value === null || value === undefined) return "-";
            if (key === 'p_value_approx' && Number(value) === 0) return Number(0).toFixed(digits);

            return Number(value).toFixed(digits);
        };

        const getColumnData = (param) => {
            const contrast = (grouped[param]?.[`Contrast_${param}`] || [])[0];
            const lsmeansTest = (grouped[param]?.[`lsmeans_${param}`] || []).find(r => r.TRTAN === TEST_TRT_NAME);
            const lsmeansRef = (grouped[param]?.[`lsmeans_${param}`] || []).find(r => r.TRTAN === REF_TRT_NAME);

            return {
                LSM_Test: getVal(lsmeansTest, 'lsmean', 4),
                LSM_Ref: getVal(lsmeansRef, 'lsmean', 4),

                GeoLSM_Test: getVal(lsmeansTest, 'geo_mean', 2),
                GeoLSM_Ref: getVal(lsmeansRef, 'geo_mean', 2),

                LSM_Difference: getVal(contrast, 'diff_log', 4),
                SE_Difference: getVal(contrast, 'se_diff', 4),
                p_value_Difference: getVal(contrast, 'p_value_approx', 4),

                Geometric_LSM_Ratio: getVal(contrast, 'ratio_pct', 2),

                Lower_Confidence_Limit: getVal(contrast, 'ratio_lower', 2),
                Upper_Confidence_Limit: getVal(contrast, 'ratio_upper', 2),

                Intra_Subject_Variability: getVal(contrast, 'Intra_CV', 2),
                Inter_Subject_Variability: getVal(contrast, 'Inter_CV', 2),
                Power: getVal(contrast, 'power', 2),
            };
        };

        const DataCell = ({ param, dataKey, className = "" }) => {
            const data = getColumnData(param);
            const value = data[dataKey] || "-";
            return (
                <td key={`${param}-${dataKey}`} className={`p-1 text-center border-top-0 border ${className}`}>
                    {value}
                </td>
            );
        };

        return (
            <div>
                <div className="text-center">
                    <Form.Label className="mb-2 fw-bold mt-3" style={{ fontSize: 12 }}>Table: Summary of Statistical comparisons for primary PK parameters</Form.Label>
                </div>
                <Table className="m-0 border-start border-end query-table">
                    <thead>
                        <tr className="border-b border-black text-center fw-bold">
                            <th className="p-1 text-left" style={{ width: '45%' }}>Parameter</th>
                            {parameters.map(p => (
                                <th className="text-center" key={p}>
                                    {p}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        <tr className="pt-2">
                            <td className="pt-2 pb-1 fw-bold border-bottom-0 border">Least Square Mean (LSM)</td>
                            {parameters.map((item => (
                                <td className="border-top-0 border-bottom-0 border"></td>
                            )))}
                        </tr>
                        <tr>
                            <td className="p-1 ps-4 border-top-0 border-bottom-0 border">Test {TEST_TRT_NAME && `(${TEST_TRT_NAME})`}</td>
                            {parameters.map((p, i) => <DataCell key={p} param={p} dataKey="LSM_Test" className={"border-bottom-0"} />)}
                        </tr>
                        <tr>
                            <td className="p-1 ps-4 border-top-0 border-bottom-0 border">Reference {REF_TRT_NAME && `(${REF_TRT_NAME})`}</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="LSM_Ref" className={"border-bottom-0"} />)}
                        </tr>

                        <tr className="pt-2">
                            <td className="pt-2 pb-1 fw-bold border-top-0 border-bottom-0 border">Geometric LSM</td>
                            {parameters.map((item => (
                                <td className="border-top-0 border-bottom-0 border"></td>
                            )))}
                        </tr>
                        <tr>
                            <td className="p-1 ps-4 border-top-0 border-bottom-0 border">Test {TEST_TRT_NAME && `(${TEST_TRT_NAME})`}</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="GeoLSM_Test" className={"border-bottom-0"} />)}
                        </tr>
                        <tr>
                            <td className="p-1 ps-4 border-top-0 border-bottom-0 border">Reference {REF_TRT_NAME && `(${REF_TRT_NAME})`}</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="GeoLSM_Ref" className={"border-bottom-0"} />)}
                        </tr>

                        <tr className="pt-2">
                            <td className="fw-bold border-top-0 border-bottom-0 border">LSM Difference ({TEST_TRT_NAME}, {REF_TRT_NAME})</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="LSM_Difference" className={"border-bottom-0"} />)}
                        </tr>
                        <tr>
                            <td className="fw-bold border-top-0 border-bottom-0 border">SE Difference</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="SE_Difference" className={"border-bottom-0"} />)}
                        </tr>
                        <tr>
                            <td className="fw-bold border-top-0 border-bottom-0 border" >p-value (Difference)</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="p_value_Difference" className={"border-bottom-0"} />)}
                        </tr>

                        <tr className="pt-2">
                            <td className="pt-2 pb-1 fw-bold border-top-0 border-bottom-0 border">Geometric LSM Ratio (%)</td>
                            {parameters.map((item => (
                                <td className="border-top-0 border-bottom-0 border"></td>
                            )))}
                        </tr>
                        <tr>
                            <td className="p-1 ps-4 border-top-0 border-bottom-0 border">Test {TEST_TRT_NAME && `(${TEST_TRT_NAME})`} / Reference {REF_TRT_NAME && `(${REF_TRT_NAME})`} (%)</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="Geometric_LSM_Ratio" className={"border-bottom-0"} />)}
                        </tr>

                        <tr className="pt-2">
                            <td className="pt-2 pb-1 fw-bold border-top-0 border-bottom-0 border">90% Confidence Interval (%)</td>
                            {parameters.map((item => (
                                <td className="border-top-0 border-bottom-0 border"></td>
                            )))}
                        </tr>
                        <tr>
                            <td className="p-1 ps-4 border-top-0 border-bottom-0 border">Test {TEST_TRT_NAME && `(${TEST_TRT_NAME})`} vs. Reference {REF_TRT_NAME && `(${REF_TRT_NAME})`}</td>
                            <td className="p-1 border-top-0 border-bottom-0 border" />
                        </tr>
                        <tr>
                            <td className="p-1 ps-5 border-top-0 border-bottom-0 border">Lower Confidence Limit</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="Lower_Confidence_Limit" className={"border-bottom-0"} />)}
                        </tr>
                        <tr>
                            <td className="p-1 ps-5 border-top-0 border-bottom-0 border">Upper Confidence Limit</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="Upper_Confidence_Limit" className={"border-bottom-0"} />)}
                        </tr>

                        <tr>
                            <td className="fw-bold p-1 border-top-0 border-bottom-0 border">Intra-Subject Variability (CV %)</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="Intra_Subject_Variability" className={"border-bottom-0"} />)}
                        </tr>
                        <tr>
                            <td className="fw-bold p-1 border-top-0 border-bottom-0 border">Inter-Subject Variability (CV %)</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="Inter_Subject_Variability" className={"border-bottom-0"} />)}
                        </tr>
                        <tr>
                            <td className="fw-bold p-1 border-top-0 border">Power (%)</td>
                            {parameters.map(p => <DataCell key={p} param={p} dataKey="Power" />)}
                        </tr>
                    </tbody>
                </Table>
            </div>
        );
    };

    const PKFullAnovaTable = (data) => {
        const anovaData = [];
        let paramKeyName = '';
        const firstTable = data?.find(d => d.name.startsWith('Anova_'));
        const paramSuffix = firstTable?.name.split('_').pop();
        const firstRow = firstTable?.table?.[0];

        if (firstRow && paramSuffix) {
            const allKeys = Object.keys(firstRow);
            paramKeyName = 'PK_Parameter';
        }

        data?.forEach(d => {
            if (d.name.startsWith('Anova_')) {
                const paramValue = d.name.split('_').pop();

                d.table?.forEach(row => {
                    anovaData.push({
                        [paramKeyName]: paramValue,
                        Source: 'Model',
                        DF: row.df_model,
                        SS: row.ss_model,
                        MS: row.ms_model,
                        F: row.f_value,
                        P: row.p_value,
                    });
                    anovaData.push({
                        [paramKeyName]: paramValue,
                        Source: 'Error',
                        DF: row.df_error,
                        SS: row.ss_error,
                        MS: row.ms_error,
                        F: undefined,
                        P: undefined,
                    });
                    anovaData.push({
                        [paramKeyName]: paramValue,
                        Source: 'Corrected Total',
                        DF: row.df_total,
                        SS: row.ss_total,
                        MS: undefined,
                        F: undefined,
                        P: undefined,
                    });
                });
            }
        });

        const getVal = (value, digits = 4, isPValue = false) => {
            if (value === undefined || value === null) return "";
            if (isPValue) {
                if (Number(value) === 0.0) return "<.0001";
                return Number(value).toFixed(digits);
            }
            if (Number.isInteger(value)) return value;
            return Number(value).toFixed(digits);
        };

        const sourceOrder = ['Model', 'Error', 'Corrected Total'];

        anovaData.sort((a, b) => {
            if (a[paramKeyName] < b[paramKeyName]) return -1;
            if (a[paramKeyName] > b[paramKeyName]) return 1;
            return sourceOrder.indexOf(a.Source) - sourceOrder.indexOf(b.Source);
        });

        const paramCounts = anovaData.reduce((acc, row) => {
            acc[row[paramKeyName]] = (acc[row[paramKeyName]] || 0) + 1;
            return acc;
        }, {});

        let lastParamValue = null;
        return (
            <div>
                <div className="text-center">
                    <Form.Label className="mb-2 fw-bold mt-3" style={{ fontSize: 12 }}>Table: ANOVA</Form.Label>
                </div>
                {anovaData.length === 0 ? (
                    <div className="text-center p-4 border">No ANOVA data found</div>
                ) : (
                    <Table className="m-0 border-start border-end query-table">
                        <thead>
                            <tr className="fw-bold">
                                <th className="p-2 text-center">Parameter</th>
                                <th className="p-2 text-left">Source</th>
                                <th className="p-2 text-center">DF</th>
                                <th className="p-2 text-center">Sum of Squares</th>
                                <th className="p-2 text-center">Mean Square</th>
                                <th className="p-2 text-center">F Value</th>
                                <th className="p-2 text-center">Pr &gt; F</th>
                            </tr>
                        </thead>
                        <tbody>
                            {anovaData.map((row, index) => {
                                const currentParamValue = row[paramKeyName];
                                const isNewParam = currentParamValue !== lastParamValue;
                                const rowSpan = paramCounts[currentParamValue];
                                lastParamValue = currentParamValue;

                                const ssDigits = 7;
                                const msDigits = 8;
                                const fDigits = 2;
                                const pDigits = 4;

                                return (
                                    <tr key={index}>
                                        {isNewParam && (
                                            <td
                                                rowSpan={rowSpan}
                                                className="p-2 text-center align-middle fw-bold"
                                            >
                                                {currentParamValue}
                                            </td>
                                        )}
                                        <td className="p-2 text-left">{row.Source}</td>
                                        <td className="p-2 text-center">{getVal(row.DF, 0)}</td>
                                        <td className="p-2 text-center">{getVal(row.SS, ssDigits)}</td>
                                        <td className="p-2 text-center">{getVal(row.MS, msDigits)}</td>
                                        <td className="p-2 text-center">{getVal(row.F, fDigits)}</td>
                                        <td className="p-2 text-center">
                                            {getVal(row.P, pDigits, true)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}
            </div>
        );
    };

    const PKType3SSTable = (data) => {
        const anovaData = [];
        let uniqueSources = new Set();
        let paramKeyName = '';
        let sourceKeyName = '';

        const firstTable = data?.find(d => d.name.startsWith('Type3_SS_'));
        const paramSuffix = firstTable?.name.split('_').pop();
        const firstRow = firstTable?.table?.[0];

        if (firstRow && paramSuffix) {
            const allKeys = Object.keys(firstRow);
            for (const key of allKeys) {
                if (firstRow[key] === paramSuffix) {
                    paramKeyName = key;
                    break;
                }
            }

            for (const key of allKeys) {
                if (typeof firstRow[key] === 'string' && key !== paramKeyName) {
                    sourceKeyName = key;
                    break;
                }
            }
        }
        data?.forEach(d => {
            if (d.name.startsWith('Type3_SS_') && paramKeyName && sourceKeyName) {
                const paramValue = d.name.split('_').pop();

                d.table?.forEach(row => {
                    const sourceValue = row[sourceKeyName];

                    if (sourceValue) {
                        uniqueSources.add(sourceValue);
                    }

                    anovaData.push({
                        [paramKeyName]: paramValue,
                        [sourceKeyName]: sourceValue,
                        DF: row.DF,
                        SS: row.SS,
                        MS: row.MS,
                        F: row.F,
                        P: row.P,
                    });
                });
            }
        });

        const dynamicSourceOrder = Array.from(uniqueSources).sort();
        const getVal = (value, digits = 4) => {
            if (value === undefined || value === null) return "-";
            if (value === 0.0) return "<.0001";
            if (value === 1.0) return "1.0000";

            if (Number.isInteger(value)) return value;

            return Number(value).toFixed(digits);
        };
        anovaData.sort((a, b) => {
            if (a[paramKeyName] < b[paramKeyName]) return -1;
            if (a[paramKeyName] > b[paramKeyName]) return 1;
            const aSource = a[sourceKeyName];
            const bSource = b[sourceKeyName];
            return dynamicSourceOrder.indexOf(aSource) - dynamicSourceOrder.indexOf(bSource);
        });

        const paramCounts = anovaData.reduce((acc, row) => {
            acc[row[paramKeyName]] = (acc[row[paramKeyName]] || 0) + 1;
            return acc;
        }, {});

        let lastParamValue = null;

        return (
            <div>
                <div className="text-center">
                    <Form.Label className="mb-2 fw-bold mt-3" style={{ fontSize: 12 }}>Table: Type III Sum of Squares</Form.Label>
                </div>
                {anovaData.length === 0 ? (
                    <div className="text-center p-4 border">No Type III Sum of Squares data found</div>
                ) : (
                    <Table className="m-0 border-start border-end query-table">
                        <thead>
                            <tr className="fw-bold">
                                <th className="p-2 text-center">Parameter</th>
                                <th className="p-2 text-left">Source</th>
                                <th className="p-2 text-center">DF</th>
                                <th className="p-2 text-center">Type III SS</th>
                                <th className="p-2 text-center">Mean Square</th>
                                <th className="p-2 text-center">F Value</th>
                                <th className="p-2 text-center">Pr &gt; F</th>
                            </tr>
                        </thead>
                        <tbody>
                            {anovaData.map((row, index) => {
                                const currentParamValue = row[paramKeyName];
                                const isNewParam = currentParamValue !== lastParamValue;
                                const rowSpan = paramCounts[currentParamValue];
                                lastParamValue = currentParamValue;

                                const ssDigits = 8;
                                const msDigits = 8;
                                const fDigits = 2;
                                const pDigits = 4;

                                return (
                                    <tr key={index}>
                                        {isNewParam && (
                                            <td
                                                rowSpan={rowSpan}
                                                className="p-2 text-center align-middle fw-bold"
                                            >
                                                {currentParamValue}
                                            </td>
                                        )}
                                        <td className="p-2 text-left">{row[sourceKeyName]}</td>
                                        <td className="p-2 text-center">{getVal(row.DF, 0)}</td>
                                        <td className="p-2 text-center">{getVal(row.SS, ssDigits)}</td>
                                        <td className="p-2 text-center">{getVal(row.MS, msDigits)}</td>
                                        <td className="p-2 text-center">{getVal(row.F, fDigits)}</td>
                                        <td className="p-2 text-center">{getVal(row.P, pDigits)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}
            </div>
        );
    };

    const PKModelInfoTable = (data) => {
        const modelInfoData = [];
        let paramValueKeyName = 'Parameter';
        let actualParamKeyName = '';
        let statKeys = [];

        const firstTable = data?.find(d => d.name.startsWith('MODEL_INFO_'));
        const paramSuffix = firstTable?.name.split('_').pop();
        const firstRow = firstTable?.table?.[0];

        if (firstRow && paramSuffix) {
            const allKeys = Object.keys(firstRow);
            for (const key of allKeys) {
                if (firstRow[key] === paramSuffix) {
                    actualParamKeyName = key;
                    break;
                }
            }
            if (actualParamKeyName) {
                statKeys = allKeys.filter(key => key !== actualParamKeyName);
            } else {
                statKeys = allKeys;
            }
            paramValueKeyName = actualParamKeyName || 'PK_Parameter';
        }

        data?.forEach(d => {
            if (d.name.startsWith('MODEL_INFO_')) {
                const paramValue = d.name.split('_').pop();

                d.table?.forEach(row => {
                    statKeys.forEach(key => {
                        modelInfoData.push({
                            [paramValueKeyName]: paramValue,
                            Key: key,
                            Value: row[key],
                        });
                    });
                });
            }
        });

        const getVal = (value, key) => {
            if (value === undefined || value === null) return "-";

            if (typeof value === 'number') {
                const numericValue = Number(value);
                if (key.toUpperCase().includes('DF')) {
                    return numericValue.toFixed(0);
                }
                return numericValue.toFixed(18);
            }
            return value;
        };

        modelInfoData.sort((a, b) => {
            if (a[paramValueKeyName] < b[paramValueKeyName]) return -1;
            if (a[paramValueKeyName] > b[paramValueKeyName]) return 1;
            return a.Key.localeCompare(b.Key);
        });

        const paramCounts = modelInfoData.reduce((acc, row) => {
            acc[row[paramValueKeyName]] = (acc[row[paramValueKeyName]] || 0) + 1;
            return acc;
        }, {});

        let lastParamValue = null;

        const formatKeyLabel = (key) => {
            return key.replace(/_/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());
        };

        return (
            <div>
                <div className="text-center">
                    <Form.Label className="mb-2 fw-bold" style={{ fontSize: 12 }}>Table: Model Info Summary</Form.Label>
                </div>
                {modelInfoData.length === 0 ? (
                    <div className="text-center p-4 border">No MODEL_INFO data found.</div>
                ) : (
                    <Table className="m-0 border-start border-end query-table">
                        <thead>
                            <tr className="fw-bold">
                                <th className="p-2 text-center" style={{ width: '20%' }}>Parameter</th>
                                <th className="p-2" style={{ width: '35%' }}>Attribute</th>
                                <th className="p-2 text-center" style={{ width: '45%' }}>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modelInfoData.map((row, index) => {
                                const currentParamValue = row[paramValueKeyName];
                                const isNewParam = currentParamValue !== lastParamValue;
                                const rowSpan = paramCounts[currentParamValue];
                                lastParamValue = currentParamValue;

                                return (
                                    <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                        {isNewParam && (
                                            <td
                                                rowSpan={rowSpan}
                                                className="p-2 text-center align-middle fw-bold"
                                            >
                                                {currentParamValue}
                                            </td>
                                        )}
                                        <td className="p-2 text-left pl-4">{formatKeyLabel(row.Key)}</td>
                                        <td className="p-2 text-center">
                                            {getVal(row.Value, row.Key)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}
            </div>
        );
    };

    const PKLsmeansFullyDynamicKeyValueTable = (data) => {
        const lsmeansData = [];
        let paramKeyName = 'Parameter';
        let trtanKeyName = 'Source';

        let actualParamKey = '';
        let actualTrtanKey = '';
        let statKeys = [];

        const firstTable = data?.find(d => d.name.startsWith('lsmeans_'));
        const paramSuffix = firstTable?.name.split('_').pop();
        const firstRow = firstTable?.table?.[0];

        if (firstRow && paramSuffix) {
            const allKeys = Object.keys(firstRow);

            for (const key of allKeys) {
                if (firstRow[key] === paramSuffix) {
                    actualParamKey = key;
                }
            }
            const stringKeys = allKeys.filter(key => typeof firstRow[key] === 'string' && key !== actualParamKey);
            if (stringKeys.length > 0) {
                actualTrtanKey = stringKeys[0];
                trtanKeyName = actualTrtanKey;
            }

            if (actualParamKey) {
                paramKeyName = actualParamKey;
            }

            statKeys = allKeys.filter(key => key !== actualParamKey && key !== actualTrtanKey);

            if (!actualTrtanKey) {
                console.error("Could not dynamically identify Treatment Arm key.");
                return null;
            }
        } else {
            return <div className="text-center p-4 border">No 'lsmeans_' data found.</div>;
        }

        data?.forEach(d => {
            if (d.name.startsWith('lsmeans_')) {
                const paramValue = d.name.split('_').pop();

                d.table?.forEach(row => {
                    const trtanValue = row[actualTrtanKey] || 'N/A';

                    statKeys.forEach(key => {
                        if (row[key] !== undefined) {
                            lsmeansData.push({
                                [paramKeyName]: actualParamKey ? row[actualParamKey] : paramValue,
                                [trtanKeyName]: trtanValue,
                                Key: key,
                                Value: row[key],
                            });
                        }
                    });
                });
            }
        });

        const getVal = (value, key) => {
            if (value === undefined || value === null) return "-";
            const numericValue = Number(value);
            if (isNaN(numericValue)) return value;
            if (key.toUpperCase().includes('P_VALUE') || key.toUpperCase() === 'P') {
                if (numericValue === 0.0) return "<.0001";
                return numericValue.toFixed(4);
            }
            if (key.toUpperCase().includes('DF')) return numericValue.toFixed(0);
            return numericValue.toFixed(8);
        };

        lsmeansData.sort((a, b) => {
            if (a[paramKeyName] < b[paramKeyName]) return -1;
            if (a[paramKeyName] > b[paramKeyName]) return 1;
            if (a[trtanKeyName] < b[trtanKeyName]) return -1;
            if (a[trtanKeyName] > b[trtanKeyName]) return 1;
            return a.Key.localeCompare(b.Key);
        });

        const paramCounts = lsmeansData.reduce((acc, row) => {
            acc[row[paramKeyName]] = (acc[row[paramKeyName]] || 0) + 1;
            return acc;
        }, {});

        const trtanCounts = lsmeansData.reduce((acc, row) => {
            const key = `${row[paramKeyName]}_${row[trtanKeyName]}`;
            acc[key] = (acc[key] || 0) + 1;
            return acc;
        }, {});

        let lastParamValue = null;
        let lastTrtanValue = null;

        const formatKeyLabel = (key) => {
            return key.replace(/_/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());
        };

        return (
            <div>
                <div className="text-center">
                    <Form.Label className="mb-2 fw-bold mt-3" style={{ fontSize: 12 }}>Table: LSMeans Summary</Form.Label>
                </div>
                {lsmeansData.length === 0 ? (
                    <div className="text-center p-4 border">No lsmeans data found</div>
                ) : (
                    <Table className="m-0 border-start border-end query-table">
                        <thead>
                            <tr className="fw-bold">
                                <th className="p-2 text-center" style={{ width: '15%' }}>{formatKeyLabel(paramKeyName)}</th>
                                <th className="p-2 text-center" style={{ width: '25%' }}>{formatKeyLabel(trtanKeyName)}</th>
                                <th className="p-2" style={{ width: '30%' }}>Attribute</th>
                                <th className="p-2 text-center" style={{ width: '30%' }}>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lsmeansData.map((row, index) => {
                                const currentParamValue = row[paramKeyName];
                                const currentTrtanValue = row[trtanKeyName];

                                const isNewParam = currentParamValue !== lastParamValue;
                                const isNewTrtan = currentTrtanValue !== lastTrtanValue || isNewParam;

                                const paramRowspan = paramCounts[currentParamValue];
                                const trtanKey = `${currentParamValue}_${currentTrtanValue}`;
                                const trtanRowspan = trtanCounts[trtanKey];

                                lastParamValue = currentParamValue;
                                lastTrtanValue = currentTrtanValue;

                                const rowClass = (currentTrtanValue.toUpperCase().includes('REF') || index % 2 === 0) ? 'bg-white' : 'bg-gray-50';

                                return (
                                    <tr key={index} className={rowClass}>
                                        {isNewParam && (
                                            <td
                                                rowSpan={paramRowspan}
                                                className="p-2 text-center align-middle fw-bold"
                                            >
                                                {currentParamValue}
                                            </td>
                                        )}
                                        {isNewTrtan && (
                                            <td
                                                rowSpan={trtanRowspan}
                                                className="p-2 text-center align-middle fw-bold"
                                            >
                                                {currentTrtanValue}
                                            </td>
                                        )}
                                        <td className="p-2 text-left pl-4">{formatKeyLabel(row.Key)}</td>
                                        <td className="p-2 text-center">
                                            {getVal(row.Value, row.Key)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}
            </div>
        );
    };

    const PKContrastFullyDynamicKeyValueTable = (data) => {
        const contrastData = [];

        const paramKeyName = 'Parameter';
        const contrastGroupKeyName = 'Contrast_Group';

        let actualParamKey = '';
        let actualContrastKey = '';
        let statKeys = [];

        const firstTable = data?.find(d => d.name.startsWith('Contrast_'));
        const paramSuffix = firstTable?.name.split('_').pop();
        const firstRow = firstTable?.table?.[0];

        if (firstRow && paramSuffix) {
            const allKeys = Object.keys(firstRow);

            for (const key of allKeys) {
                if (firstRow[key] === paramSuffix) {
                    actualParamKey = key;
                    break;
                }
            }
            const stringKeys = allKeys.filter(key => typeof firstRow[key] === 'string' && key !== actualParamKey);
            if (stringKeys.length > 0) {
                actualContrastKey = stringKeys[0];
            }
            statKeys = allKeys.filter(key => key !== actualParamKey && key !== actualContrastKey);

            if (!actualContrastKey) {
                console.error("Could not dynamically identify Contrast Key.");
                return <div className="text-center p-4 border">Error: Could not dynamically identify Contrast Key.</div>;
            }
        } else {
            return <div className="text-center p-4 border">No 'Contrast_' data found.</div>;
        }

        data?.forEach(d => {
            if (d.name.startsWith('Contrast_')) {
                const paramValue = d.name.split('_').pop();

                d.table?.forEach(row => {
                    const contrastValue = row[actualContrastKey] || 'N/A';

                    statKeys.forEach(key => {
                        if (row[key] !== undefined) {
                            contrastData.push({
                                [paramKeyName]: paramValue,
                                [contrastGroupKeyName]: contrastValue,
                                Key: key,
                                Value: row[key],
                            });
                        }
                    });
                });
            }
        });

        const getVal = (value, key) => {
            if (value === undefined || value === null) return "-";

            const numericValue = Number(value);
            if (isNaN(numericValue)) return value;

            if (key.toUpperCase().includes('P_VALUE') || key.toUpperCase() === 'P') {
                if (numericValue === 0.0) return "<.0001";
                return numericValue.toFixed(4);
            }

            return numericValue.toFixed(8);
        };

        contrastData.sort((a, b) => {
            if (a[paramKeyName] < b[paramKeyName]) return -1;
            if (a[paramKeyName] > b[paramKeyName]) return 1;
            if (a[contrastGroupKeyName] < b[contrastGroupKeyName]) return -1;
            if (a[contrastGroupKeyName] > b[contrastGroupKeyName]) return 1;
            return a.Key.localeCompare(b.Key);
        });

        const paramCounts = contrastData.reduce((acc, row) => {
            acc[row[paramKeyName]] = (acc[row[paramKeyName]] || 0) + 1;
            return acc;
        }, {});

        const contrastCounts = contrastData.reduce((acc, row) => {
            const key = `${row[paramKeyName]}_${row[contrastGroupKeyName]}`;
            acc[key] = (acc[key] || 0) + 1;
            return acc;
        }, {});

        let lastParamValue = null;
        let lastContrastValue = null;

        const formatKeyLabel = (key) => {
            return key.replace(/_/g, ' ')
                .replace(/\b\w/g, c => c.toUpperCase());
        };

        return (
            <div>
                <div className="text-center">
                    <Form.Label className="mb-2 fw-bold mt-3" style={{ fontSize: 12 }}>Table: Contrast</Form.Label>
                </div>
                {contrastData.length === 0 ? (
                    <div className="text-center p-4 border">No Contrast data found</div>
                ) : (
                    <Table className="m-0 border-start border-end query-table">
                        <thead>
                            <tr className="bg-gray-200 fw-bold">
                                <th className="p-2 text-center" style={{ width: '15%' }}>{formatKeyLabel(paramKeyName)}</th>
                                <th className="p-2 text-center" style={{ width: '25%' }}>{formatKeyLabel(contrastGroupKeyName)}</th>
                                <th className="p-2 text-center" style={{ width: '30%' }}>Attribute</th>
                                <th className="p-2 text-center" style={{ width: '30%' }}>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contrastData.map((row, index) => {
                                const currentParamValue = row[paramKeyName];
                                const currentContrastValue = row[contrastGroupKeyName];

                                const isNewParam = currentParamValue !== lastParamValue;
                                const isNewContrast = currentContrastValue !== lastContrastValue || isNewParam;

                                const paramRowspan = paramCounts[currentParamValue];
                                const contrastKey = `${currentParamValue}_${currentContrastValue}`;
                                const contrastRowspan = contrastCounts[contrastKey];

                                lastParamValue = currentParamValue;
                                lastContrastValue = currentContrastValue;

                                const rowClass = index % 2 === 0 ? 'bg-white' : 'bg-gray-50';

                                return (
                                    <tr key={index} className={rowClass}>
                                        {isNewParam && (
                                            <td
                                                rowSpan={paramRowspan}
                                                className="p-2 text-center align-middle fw-bold"
                                            >
                                                {currentParamValue}
                                            </td>
                                        )}
                                        {isNewContrast && (
                                            <td
                                                rowSpan={contrastRowspan}
                                                className="p-2 text-center align-middle fw-bold"
                                            >
                                                {currentContrastValue}
                                            </td>
                                        )}
                                        <td className="p-2 text-left pl-4">{formatKeyLabel(row.Key)}</td>
                                        <td className="p-2 text-center">
                                            {getVal(row.Value, row.Key)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}
            </div>
        );
    };
    return (
        <div>
            {PKModelInfoTable(output || [])}
            {PKLsmeansFullyDynamicKeyValueTable(output || [])}
            {PKContrastFullyDynamicKeyValueTable(output || [])}
            {PKType3SSTable(output || [])}
            {PKFullAnovaTable(output || [])}
            {GLXBABEGLMOUTPUT(output || [])}
        </div>
    );
};

export default GLXBABEGLM;
